// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SentryJs from "./Sentry.js";
import * as Belt_Option from "../../../rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../rescript/lib/es6/caml_option.js";

function init(prim) {
  SentryJs.init(prim);
  
}

function captureException(prim) {
  return SentryJs.captureException(prim);
}

function captureExceptionWithContext(prim0, prim1) {
  return SentryJs.captureExceptionWithContext(prim0, prim1);
}

function captureMessage(prim) {
  return SentryJs.captureMessage(prim);
}

function captureMessageWithContext(prim0, prim1) {
  return SentryJs.captureMessageWithContext(prim0, prim1);
}

function capturePromiseError(prim) {
  return SentryJs.capturePromiseError(prim);
}

function capturePromiseErrorWithContext(prim0, prim1) {
  return SentryJs.capturePromiseErrorWithContext(prim0, prim1);
}

function setTag(prim0, prim1) {
  SentryJs.setTag(prim0, prim1);
  
}

function setUser(prim0, prim1) {
  SentryJs.setUser(prim0, prim1);
  
}

function setContext(prim0, prim1) {
  SentryJs.setContext(prim0, prim1);
  
}

function withProfiler(prim) {
  return SentryJs.withProfiler(prim);
}

function initSentry(options) {
  var prim = {
    dsn: options.dsn,
    environment: options.environment,
    tracesSampleRate: Belt_Option.getWithDefault(Caml_option.undefined_to_opt(options.tracesSampleRate), 0.05),
    replaysSessionSampleRate: Belt_Option.getWithDefault(Caml_option.undefined_to_opt(options.replaysSessionSampleRate), 0.05),
    replaysOnErrorSampleRate: Belt_Option.getWithDefault(Caml_option.undefined_to_opt(options.replaysOnErrorSampleRate), 0.05)
  };
  SentryJs.init(prim);
  
}

export {
  init ,
  captureException ,
  captureExceptionWithContext ,
  captureMessage ,
  captureMessageWithContext ,
  capturePromiseError ,
  capturePromiseErrorWithContext ,
  setTag ,
  setUser ,
  setContext ,
  withProfiler ,
  initSentry ,
  
}
/* ./Sentry.js Not a pure module */
